export const endPoints = "https://iqrdemo.ryscocorrosion.com/iqr_system_backend/api/";